import * as React from 'react'
import type { SVGProps } from 'react'
import { forwardRef } from 'react'
import type { Ref } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLandmark = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 20'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='landmark_svg__a'
      width={18}
      height={20}
      x={1}
      y={0}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill={props.color}
        d='M17.5 17.5a.833.833 0 0 1 0 1.667h-15a.833.833 0 0 1 0-1.667zM5 8.334c.46 0 .833.373.833.833V15a.833.833 0 0 1-1.667 0V9.167c0-.46.373-.833.833-.833M8.333 8.334c.46 0 .833.373.833.833V15a.833.833 0 0 1-1.667 0V9.167c0-.46.373-.833.834-.833M11.666 8.334c.46 0 .833.373.833.833V15a.833.833 0 0 1-1.666 0V9.167c0-.46.373-.833.833-.833M15 8.334c.46 0 .832.373.833.833V15a.833.833 0 0 1-1.667 0V9.167c0-.46.373-.833.833-.833'
      />
      <path
        fill={props.color}
        fillRule='evenodd'
        d='M10.003.831c.38.001.755.09 1.096.257l6.555 3.206c1.19.583.774 2.373-.55 2.373H2.895c-1.328 0-1.734-1.791-.55-2.372L8.9 1.083h.002a2.5 2.5 0 0 1 1.1-.252m-.006 1.667a.8.8 0 0 0-.367.084l-.001-.001L4.692 5h10.612l-4.938-2.415-.002-.002a.84.84 0 0 0-.367-.086'
        clipRule='evenodd'
      />
    </mask>
    <g mask='url(#landmark_svg__a)'>
      <path  fill={props.color} fillOpacity={0.6} d='M0 0h20v20H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgLandmark)
export default ForwardRef
